import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '../store/user'
import { useSeatsStore } from '../store/seats'
import { LAUNCH_UTC_MS } from '../launch.js'
const Admin = () => import('../views/admin/index.vue')
const AdminSeats = () => import('../views/admin/Seats.vue')
const AdminOrders = () => import('../views/admin/Orders.vue')
const AdminReset = () => import('../views/admin/Reset.vue')
const Landing = () => import('../views/landing/index.vue')
const Home = () => import('../views/home/index.vue')
const Booking = () => import('../views/booking/index.vue')
const ThankYou = () => import('../views/thank-you/index.vue')
const Login = () => import('../views/admin/Login.vue')

const isLaunchReached = () => Date.now() >= LAUNCH_UTC_MS

const routes = [
    {
        path: '/admin',
        name: 'admin',
        component: Admin,
        redirect: {
            name: 'AdminSeats'
        },
        beforeEnter: async (to, from, next) => {
            if (useUserStore().user) {
                next()
                return
            }

            await useUserStore().getUser()

            if (useUserStore().user) {
                next()
            } else {
                next({ name: 'login' })
            }
        },
        children: [
            {
                path: 'seats',
                name: 'AdminSeats',
                component: AdminSeats,
            },
            {
                path: 'orders',
                name: 'AdminOrders',
                component: AdminOrders,
            },
            {
                path: 'reset',
                name: 'AdminReset',
                component: AdminReset,
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: async (to, from, next) => {
            if (!useUserStore().user) {
                next()
                return
            }

            await useUserStore().getUser()

            if (useUserStore().user) {
                next({ name: 'admin' })
            } else {
                next()
            }
        }
    },
    {
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter: (to, from, next) => {
            if (!isLaunchReached()) {
                next({ name: 'landing' })
            } else {
                next()
            }
        }
    },
    {
        path: '/waiting',
        name: 'landing',
        component: Landing
    },
    {
        path: '/test',
        component: Home
    },
    {
        path: '/booking',
        name: 'booking',
        component: Booking,
        beforeEnter: (to, from, next) => {
            if (useSeatsStore().selected.length > 0) {
                next()
                return
            }

            next({ name: 'home' })
        }
    },
    {
        path: '/thank-you',
        name: 'thank-you',
        component: ThankYou
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
